import { TRANSPARENT_PIXEL, type CanvasJSONLikeObject } from '@doer/frontend-components/creativity-editor';

export const STORES_GRID_MAX = 9;

interface StoresGridOpts {
  pieceId?: string;
  position: { left: number; top: number; width: number; height: number };
  maxSlots?: number;
  rowGap?: number;
  colGap?: number;
  maxItemHeight?: number;
}

const emptySlot = (): CanvasJSONLikeObject => ({
  type: 'Image',
  version: '7.1.0',
  src: TRANSPARENT_PIXEL,
  crossOrigin: 'anonymous',
  originX: 'center',
  originY: 'center',
  left: 0,
  top: 0,
  width: 80,
  height: 80,
  scaleX: 1,
  scaleY: 1,
  visible: false,
  selectable: true,
  evented: true,
  objectCaching: false
});

/** Grilla de logos de comercios (réplica scoped de buildBrandLogos de Macro). */
export function buildStoresGrid(opts: StoresGridOpts): CanvasJSONLikeObject {
  const slots = opts.maxSlots ?? STORES_GRID_MAX;
  return {
    pieceId: opts.pieceId ?? 'stores-grid',
    type: 'Group',
    version: '7.1.0',
    originX: 'center',
    originY: 'center',
    left: opts.position.left,
    top: opts.position.top,
    width: opts.position.width,
    height: opts.position.height,
    objectCaching: false,
    selectable: true,
    evented: true,
    layoutManager: { type: 'layoutManager', strategy: 'fixed' },
    groupCollection: {
      type: 'grid',
      width: opts.position.width,
      height: opts.position.height,
      rowGap: opts.rowGap ?? 16,
      colGap: opts.colGap ?? 24,
      maxItemHeight: opts.maxItemHeight ?? 120,
      urlPath: 'imageUrl'
    },
    objects: Array.from({ length: slots }, emptySlot)
  };
}
